<template>
<v-container class="mt-5">
    <v-row>
        <v-col lg="12" sm="12">

            <v-row justify="center">
                <v-col align-self="start" class="d-flex justify-center align-center pa-0" cols="12">
                    <v-avatar class="profile avatar-center-heigth" color="grey" size="80">

                        <v-img height="80px" :src="require('@/assets/image_logo.png/')"></v-img>

                    </v-avatar>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-center py-0" cols="12">
                    <v-list-item color="#0000" class="profile-text-name">
                        <v-list-item-content>
                            <v-list-item-subtitle>User Name :  {{ user_name }}</v-list-item-subtitle>
                         
                            <!-- <v-list-item-subtitle> {{ items[0].en_ba }}</v-list-item-subtitle> -->
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" lg="12" sm="12" class="text-center">
                    <v-list-item-content class="sutitles">
                        <v-list-item-subtitle>User ID : {{ user_id }} </v-list-item-subtitle>
                   

                    </v-list-item-content>

                </v-col>
         

            </v-row>
            <v-row>
                <v-col cols="12" lg="12" sm="12" class="text-center">
                    <v-list-item-content class="sutitles">
                        <v-list-item-subtitle>Telegram ID : {{ telegram_id }}</v-list-item-subtitle>
                   

                    </v-list-item-content>

                </v-col>
         

            </v-row>
            <v-row>
                <v-col cols="12" lg="12" sm="12" class="text-center">

                    <v-btn class="red white--text font-weight-black" text @click="logout()">
        
                        <v-icon class="white--text font-weight-black">mdi-power</v-icon>

                    </v-btn> 

                </v-col>
         

            </v-row>
          
        </v-col>
    </v-row>
</v-container>
</template>

<script>
export default {

    name: "account",
    data:()=>({
        user_id:'',
        user_name:'',
        telegram_id:'',
        exp_date:'',
    }),
    created() {
        
        var userData = JSON.parse(localStorage.getItem('info'))
        this.user_id = userData.data.user.id
        this.user_name = userData.data.user.username;
        this.telegram_id = userData.data.user.id_tele;
        this.exp_date = userData.data.user.trail_ends_at

    },
    mounted() {

    },
    methods: {

        logout() {
            localStorage.removeItem('hasLogin')
            localStorage.removeItem('info')
            this.$router.push({
                name: "login"
            });
            this.$store.commit("setAuthentication", false);
        },
    }

}
</script>
